import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SignupService } from '../services/signup.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonService } from '../services/common.service';
import { patterns } from '../../assets/patterns';

@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.css']
})
export class PasswordresetComponent implements OnInit {

  passwordDetails: UntypedFormGroup;
  userCode: string;
  password: any;
  public loading = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private signupService: SignupService,
    private route: ActivatedRoute,
    private commonService: CommonService
  ) {
    this.route.params.subscribe(params => {
      this.userCode = params.userUniqueCode;
    })
  }

  ngOnInit() {
    this.commonService.checkLoggedInUser();
    this.passwordDetails = this.formBuilder.group({
      password: ['', [Validators.required, Validators.pattern(patterns.passwordPattern)]],
      conformPassword: ['', Validators.required]
    });
  }

  resetPassword() {
    if (this.passwordDetails.invalid) {
      this.passwordDetails.markAllAsTouched();
      return false;
    }
    this.loading = true;
    this.signupService.resetPassword(this.passwordDetails.value, this.userCode).subscribe(() => {
      this.loading = false;
      this.router.navigate(['/passwordresetsuccess']);
    }, () => {
      this.loading = false;
    });
  }
}
